// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__dXxko","header":"MergedInvoice_header__28sM2"};